import styled from '@emotion/styled'

export const ModalTitle = styled('b')``

export const ModalContent = styled('div')`
  padding-top: 10px;
  color: #666666;
`
